import styled from '@emotion/styled';
import React from 'react';
import withStyleSystem from '../withStyleSystem';

const Box = withStyleSystem(styled.div());
export type BoxProps = React.ComponentPropsWithRef<typeof Box>;
export default Box;
